import * as React from 'react';
import { useEffect } from 'react';
import NestedDrawerButton from '@/components/buttons/NestedDrawerButton';
import styles from '@/components/menu/MenuHeader/index.less';
import { CalendarOutlined, UserAddOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useDispatch, useModel } from 'umi';
import { F, INTL_ACTION, INTL_ENTITY } from '@/utils/intl';
import HotkeyHint from '@/components/Hotkey';
import { CheckAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import FEATURE_FLAGS from '@/constants/featureFlags';
import { CMD_SHORTCUTS } from '@/constants/shortcuts';

const LeadManagementQuickActions: React.FC = () => {
  const {initialState} = useModel('@@initialState');
  const dispatch = useDispatch();

  const HOTKEY_MAP = {
    ADD_LEAD: CMD_SHORTCUTS.ADD_LEAD,
    BOOK_APPOINTMENT: CMD_SHORTCUTS.BOOK_APPOINTMENT,
  };

  const onAddLeadClick = () => {
    dispatch({
      type: 'leads/toggleAddLeadsDrawer',
    });
  };
  const onBookAppointmentClick = () => {
    dispatch({
      type: 'serviceRequest/toggleCreateServiceRequestDrawer',
      payload: {
        open: true,
        openAppointmentDetails: true
      }
    })
  };
  useEffect(() => {
    const commandHandlers = {
      [HOTKEY_MAP.ADD_LEAD]: onAddLeadClick,
      [HOTKEY_MAP.BOOK_APPOINTMENT]: onBookAppointmentClick,
    };
    const handleKeyDown = (event) => {
      if (event.metaKey || event.ctrlKey) {
        const handler = commandHandlers[event.key.toLowerCase()];
        if (handler) handler();
      }
    };

    // Add the event listener
    document.addEventListener('keydown', handleKeyDown);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      margin: '0 10px'
    }}>

      <CheckAccess feature={FEATURE_FLAGS.LEAD_MANAGEMENT} access={[PERMISSIONS.Leads.CREATE, PERMISSIONS.BUSINESS_PARTNER]} asterisk>
        <NestedDrawerButton
          block
          className={styles.leadManagementQuickActionButton}
          onClick={onAddLeadClick}
        >
          {!initialState.collapsed ? (
            <div className={styles.buttonContent}>
              <Space>
                <UserAddOutlined/>
                <F id={'pages.leads.create_lead_quick_access'} defaultMessage={'New Customer/Project'}/>
              </Space>
              <span className={styles.shortcut}>
                <HotkeyHint hotkey={HOTKEY_MAP.ADD_LEAD}/>
              </span>
            </div>
          ) : (
            <UserAddOutlined/>
          )}
        </NestedDrawerButton>
      </CheckAccess>
      <CheckAccess feature={FEATURE_FLAGS.SCHEDULER} access={[PERMISSIONS.ServiceRequests.CREATE, PERMISSIONS.BUSINESS_PARTNER]} asterisk>
        <NestedDrawerButton
          block
          className={styles.leadManagementQuickActionButton}
          onClick={onBookAppointmentClick}
        >
          {!initialState.collapsed ? (
            <div className={styles.buttonContent}>
              <Space>
                <CalendarOutlined/>
                <F entity={INTL_ENTITY.APPOINTMENT} action={INTL_ACTION.CREATE} />
              </Space>
              <span className={styles.shortcut}>
                <HotkeyHint hotkey={HOTKEY_MAP.BOOK_APPOINTMENT}/>
              </span>
            </div>
          ) : (
            <CalendarOutlined/>
          )}
        </NestedDrawerButton>
      </CheckAccess>
    </div>
  );
};
export default LeadManagementQuickActions;
